import React from 'react';
import { Stack } from '@fiverr-private/layout_components';
import { Button } from '@fiverr-private/button';
import { Heading, Text } from '@fiverr-private/typography';
import { PlayCircleSolidIcon } from '@fiverr-private/visuals';
import { BriefCreationHowToModal, HowToMiraModal } from '@fiverr-private/dm_brief_creation';
import { CreateBriefButton } from '../../CreateBriefButton';
import { AppI18n } from '../../../i18n';
import { useInitialProps } from '../../../context';
import EmptyBriefs from '../../../../assets/empty-briefs.gif';

export const NoBriefsState = () => {
  const { rollouts } = useInitialProps();
  const inMiraRollout = Boolean(rollouts?.inCrowsPythonsAgenticBriefs);

  const titleCopy = inMiraRollout ? 'empty.title_mira' : 'empty.title';
  const descriptionCopy = inMiraRollout ? 'empty.description_mira' : 'empty.description';
  const ctaCopy = inMiraRollout ? 'empty.cta_mira' : 'empty.cta';
  const HowItWorksModal = inMiraRollout ? HowToMiraModal : BriefCreationHowToModal;

  return (
    <Stack gap="14" direction="column" alignItems="center" justifyContent="center" minHeight="60vh">
      <Stack gap="8" direction="column" alignItems="center">
        <img src={EmptyBriefs} alt="empty" width={250} height={188} />
        <Stack gap="2" direction="column" justifyContent="center" alignItems="center">
          <Heading as="h4" textAlign="center">
            <AppI18n k={titleCopy} />
          </Heading>
          <Text textAlign="center" maxWidth="450px">
            <AppI18n k={descriptionCopy} />
          </Text>
        </Stack>
      </Stack>
      <Stack gap="2" direction="column" justifyContent="center" alignItems="center">
        <CreateBriefButton title={<AppI18n k={ctaCopy} />} />
        <HowItWorksModal>
          <Button variant="ghost">
            <PlayCircleSolidIcon />
            <AppI18n k="empty.how_does_it_work" />
          </Button>
        </HowItWorksModal>
      </Stack>
    </Stack>
  );
};
